const ITEMS = [
  "Pour",
  "Turn",
  "Enjoy",
  "Hand-cranked",
  "No batteries. No cords.",
  "A new twist on snack time",
];

const MarqueeList = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 text-sm font-black uppercase tracking-[0.28em] text-[#F7F1E6] sm:text-base">
          {item}
        </span>
        <img src="/assets/icon-32.png" alt="" aria-hidden="true" className="h-7 w-7 object-contain" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-[#043436] bg-[#074345] py-5"
  >
    <div className="marquee-track flex w-max">
      <MarqueeList />
      <MarqueeList />
    </div>
  </div>
);
